// extracted by mini-css-extract-plugin
module.exports = {"nav":"style__nav__mxhNj","item":"style__item__Px1il","current":"style__current__29bPL","new":"style__new__yC6X-","allowed":"style__allowed__dGz4K"};